import AddComment20 from '@carbon/icons-react/es/add-comment/20';
import ListChecked20 from '@carbon/icons-react/es/list--checked/20';
import { Tooltip, Badge } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as Approval } from 'assets/svgs/approve-outline-20.svg';
import { ReactComponent as Conversation } from 'assets/svgs/conversation.svg';
import { TabNames } from '../../document.types';

interface Props {
  count: number;
}

const Content = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  color: var(--gray-70);
`;

export const DiscussionsTabLabel: FC<Props> = ({ count }) => {
  return (
    <Tooltip
      placement="left"
      title={<FormattedMessage id={TabNames.CommentsTab} />}
    >
      <Content>
        <AddComment20 />
        <Badge size="small" dot={count > 0} />
      </Content>
    </Tooltip>
  );
};

export const ConversationsTabLabel: FC<Props> = ({ count }) => {
  return (
    <Tooltip
      placement="left"
      title={<FormattedMessage id={TabNames.ConversationsTab} />}
    >
      <Content data-cy="chat.trigger">
        <Conversation />
        <Badge size="small" dot={count > 0} />
      </Content>
    </Tooltip>
  );
};

export const TasksTabLabel: FC<Props> = ({ count }) => {
  return (
    <Tooltip placement="left" title={<FormattedMessage id={TabNames.Tasks} />}>
      <Content data-cy="spaces-add-tasks-tab">
        <ListChecked20 />
        <Badge size="small" dot={count > 0} />
      </Content>
    </Tooltip>
  );
};

export const ApprovalsTabLabel: FC<Props> = ({ count }) => {
  return (
    <Tooltip
      placement="left"
      title={<FormattedMessage id={TabNames.Approvals} />}
    >
      <Content>
        <Approval />
        <Badge size="small" dot={count > 0} />
      </Content>
    </Tooltip>
  );
};
